import { Component, Inject, OnInit, PLATFORM_ID } from "@angular/core";
import { CommonModule, isPlatformBrowser } from "@angular/common";
import { NavigationEnd, Router, RouterOutlet } from "@angular/router";
import { filter } from "rxjs/operators";
import { getCurrentUserId } from "./helpers/utils";
import { environment } from "../environments/environment";
import { AuthService } from "./services/auth.service";
import { SecureStorageService } from "./services/secure-storage.service";
import { UploadProgressComponent } from "./shared/components/upload-progress/upload-progress.component";
import { SeoService } from "./services/seo.service";

declare let gtag: Function;

@Component({
  selector: "app-root",
  standalone: true,
  imports: [CommonModule, RouterOutlet, UploadProgressComponent],
  templateUrl: "./app.component.html",
  styleUrl: "./app.component.scss",
})
export class AppComponent implements OnInit {
  private readonly siteUrl = 'https://yokastar.com';
  private readonly isBrowser: boolean;

  constructor(
    private router: Router,
    private authService: AuthService,
    private secureStorage: SecureStorageService,
    private seoService: SeoService,
    @Inject(PLATFORM_ID) platformId: object
  ) {
    this.isBrowser = isPlatformBrowser(platformId);
  }

  ngOnInit(): void {
    const userId = getCurrentUserId();
    if (userId) {
      this.authService.checkIsAdmin(userId).subscribe();
    }

    this.router.events
      .pipe(filter((event) => event instanceof NavigationEnd))
      .subscribe((event: NavigationEnd) => {
        const cleanUrl = event.urlAfterRedirects.split('?')[0].split('#')[0];
        const canonicalUrl = `${this.siteUrl}${cleanUrl === '/' ? '' : cleanUrl}`;
        this.seoService.updateCanonicalUrl(canonicalUrl || this.siteUrl);

        if (this.isBrowser && typeof gtag === 'function') {
          gtag("config", "G-KEPLP53PLT", {
            page_path: event.urlAfterRedirects,
          });
        }
      });

    if (!this.isBrowser) {
      return;
    }

    const url = window.location.href;
    if (url.includes('token=')) {
      const token = new URL(url).searchParams.get('token');
      if (token) {
        localStorage.setItem('token', token);
        this.router.navigate(['/']);
      }
    }
  }
}
